<template>
  <div class="animated fadeIn pt2 pb2">
    <div class="clearfix gibson px2 py3 mb2">
      <div class="col-12 px2">
        <div class="clearfix border muted-border p2 py3 shadow" v-if="showMobile">
          <div class="col-12 px2">
            <p class="h4 semi-bold line-height-2 my2 darkblue">Skift kodeord</p>
          </div>
          <div class="col-12 px0">
            <form @submit="onSubmit">
              <div class="clearfix">
                <div class="col-12 px0">
                  <vue-password v-model="form.password" @input="password_check" :strengthMessages="strengthMessages" required  classes="not-rounded border-none muted-background mb1 pt3 pr0 pb3 pl3 h5 flex justify-center items-center" placeholder="Nyt kodeord" autocomplete="current-password" :score="score"></vue-password>
                </div>
              </div>
              <div class="py2"></div>
              <div class="clearfix">
                <div class="col-12 px0">
                  <b-form-input v-model="form.newpassword" type="password" placeholder="Gentag kodeord" required class="not-rounded border-none muted-background mb3 pt3 pr0 pb3 pl3 h5 flex justify-center items-center" autocomplete="current-password"></b-form-input>
                </div>
              </div>
              <div class="clearfix">
                <div class="alert alert-danger" v-if="form.errorMessage">{{ form.errorMessage }}</div>
              </div>
              <div class="clearfix">
                <div class="col-12 px2">
                  <p class="frmValidation" :class="{'frmValidation--passed' : form.password.length > 7}"><i class="mr1" :class="form.password.length > 7 ? 'el-icon-check' : 'el-icon-close'"></i> Længere end 7 karakterer</p>
                  <p class="frmValidation" :class="{'frmValidation--passed' :has_uppercase }"><i class="mr1" :class="has_uppercase ? 'el-icon-check' : 'el-icon-close'"></i> Indeholder et stort bogstav</p>
                  <p class="frmValidation" :class="{'frmValidation--passed' :has_lowercase }"><i class="mr1" :class="has_lowercase ? 'el-icon-check' : 'el-icon-close'"></i> Indeholder et lille bogstav</p>
                  <p class="frmValidation" :class="{'frmValidation--passed' : has_number }"><i class="mr1" :class="has_number ? 'el-icon-check' : 'el-icon-close'"></i> Indeholder et tal</p>
                  <p class="frmValidation" :class="{'frmValidation--passed' : has_special }"><i class="mr1" :class="has_special ? 'el-icon-check' : 'el-icon-close'"></i> Indeholder et specialkarakter</p>
                </div>
              </div>
              <div class="clearfix mt3">
                <div class="col-12 px2 flex justify-between items-center">
                  <a href="#/newsfeed" class="muted-button p3 no-hover h4 mb0">Tilbage</a>
                  <button type="submit" id="formLogin" class="action-button h4 p3 gibson not-rounded border-none">
                    <span>Gem</span>
                  </button>
                </div>
              </div>
            </form>
            <loading :show="show" :label="label" :overlay="overlay"></loading>
            <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
          </div>
        </div>
        <div class="clearfix p2 py3 ml4" v-if="!showMobile">
          <div class="col-12 px2 mb2">
            <p class="h4 semi-bold line-height-2 mb4 darkblue">Skift kodeord</p>
          </div>
          <div class="col-12 px2">
            <form @submit="onSubmit">
              <div class="clearfix">
                <div class="col-6 px0">
                  <vue-password v-model="form.password" @input="password_check" :strengthMessages="strengthMessages" required classes="not-rounded border-none muted-background mb1 p2 flex justify-center items-center" placeholder="Nyt kodeord" autocomplete="current-password" :score="score"></vue-password>
                </div>
              </div>
              <div class="py2"></div>
              <div class="clearfix">
                <div class="col-6 px0 mb2">
                  <b-form-input v-model="form.newpassword" type="password" placeholder="Gentag kodeord" required class="not-rounded border-none muted-background mb1 p2 h5 flex justify-center items-center" autocomplete="current-password" style="font-size;16px;"></b-form-input>
                </div>
              </div>
              <div class="clearfix">
                <div class="alert alert-danger" v-if="form.errorMessage">{{ form.errorMessage }}</div>
              </div>
              <div class="clearfix">
                <div class="col-6 px2">
                  <p class="frmValidation" :class="{'frmValidation--passed' : form.password.length > 7}">
                    <i class="mr1" :class="form.password.length > 7 ? 'el-icon-check green' : 'el-icon-close red'"></i>
                    <span>Længere end 7 karakterer</span>
                  </p>
                  <p class="frmValidation" :class="{'frmValidation--passed' :has_uppercase }"><i class="mr1" :class="has_uppercase ? 'el-icon-check green' : 'el-icon-close red'"></i> Indeholder et stort bogstav</p>
                  <p class="frmValidation" :class="{'frmValidation--passed' :has_lowercase }"><i class="mr1" :class="has_lowercase ? 'el-icon-check green' : 'el-icon-close red'"></i> Indeholder et lille bogstav</p>
                  <p class="frmValidation" :class="{'frmValidation--passed' : has_number }"><i class="mr1" :class="has_number ? 'el-icon-check green' : 'el-icon-close red'"></i> Indeholder et tal</p>
                  <p class="frmValidation" :class="{'frmValidation--passed' : has_special }"><i class="mr1" :class="has_special ? 'el-icon-check green' : 'el-icon-close red'"></i> Indeholder et specialkarakter</p>
                </div>
              </div>
              <div class="clearfix mt3">
                <div class="col-6 px2 flex justify-between items-center">
                  <a href="#/newsfeed" class="outlined-disabled-button p2 gibson h5 line-height-1 flex justify-center items-center">
                    <span class="mr1"><i class="el-icon-back"></i></span>
                    <span>Tilbage</span>
                  </a>
                  <button type="submit" id="formLogin" class="action-button h5 p2 gibson not-rounded border-none line-height-1 regular px3 flex justify-center items-center">
                    <span>Gem</span>
                    <span><i class="el-icon-right"></i></span>
                  </button>
                </div>
              </div>
            </form>
            <loading :show="show" :label="label" :overlay="overlay"></loading>
            <simplert :useRadius="true" :useIcon="true" ref="simplert"></simplert>
            <updatebitrixpackagepermission   ref="updatebitrixpackagepermission"></updatebitrixpackagepermission>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import loading from 'vue-full-loading'
import Header from '../components/Header'
import updatebitrixpackagepermission from '../components/updatebitrixpackagepermission'
import VuePassword from 'vue-password'
import passwordStrength from 'zxcvbn'
import Simplert from 'vue2-simplert'
export default {
  name: 'Paasword',
  components: {
    Header,
    Simplert,
    passwordStrength,
    VuePassword,
    loading,
    updatebitrixpackagepermission
  },
  data: function () {
    return {
      form: {
        password: '',
        newpassword: '',
        errorMessage: ''
      },
      strengthMessages: ['Meget svagt', 'Svagt', 'Medium', 'Stærkt', 'Meget stærkt'],
      has_number: false,
      has_lowercase: false,
      has_uppercase: false,
      has_special: false,
      show: false,
      label: 'Loading...',
      loading: true,
      score: 0,
      projectPerson: '',
      overlay: false
    }
  },
  created () {
    if (screen.width <= 640) {
      this.showMobile = true
    } else {
      this.showMobile = false
    }
    if (screen.width > 1280) {
      this.showLarge = true
    }
    this.projectPerson = localStorage.getItem('id_token_portal')
    if (this.projectPerson === null) {
      this.$router.push('/login')
    }
  },
  methods: {
    onSubmit (evt) {
      evt.preventDefault()
      this.form.errorMessage = ''
      if (this.form.password !== this.form.newpassword) {
        this.form.errorMessage = 'Du har indtastet to passwords som ikke er ens. Prøv igen.'
        return
      }
      this.score = passwordStrength(this.form.password).score
      if (this.score < 3) {
        this.form.errorMessage = 'Dit password er ikke stærkt nok.'
        return
      }
      this.show = true
      // alert(JSON.stringify(this.form))
      this.salesPerson = localStorage.getItem('id_token_portal')
      var data = {operation: 'changePassword', salesPerson: this.salesPerson, password: this.form.password}
      this.$http.post('', data, { emulateJSON: true })
        .then(
          response => {
            this.show = false
            var res = response.body
            if (res.success) {
              let closeFn = function () {
                this.$router.push('/newsfeed')
              }
              let obj = {
                title: 'Gennemført!',
                message: '',
                type: 'success',
                onClose: closeFn
              }
              this.$refs.simplert.openSimplert(obj)
            } else {
              this.form.errorMessage = 'Det er en fejl med dit adgangskode, prøv igen'
            }
          },
          response => {
            alert('error')
          }
        )
    },
    forgotPassword (evt) {
      this.$router.push('/glemte-password')
    },
    password_check: function () {
      this.has_number = /\d/.test(this.form.password)
      this.has_lowercase = /[a-z]/.test(this.form.password)
      this.has_uppercase = /[A-Z]/.test(this.form.password)
      this.has_special = /[!@#\\$%\\^\\&*\\)\\(+=._-]/.test(this.form.password)
    }
  }
}
</script>
<style>
.frmField{background-color:white; color:#495057; line-height: 1.25; font-size: 16px; font-family: 'Roboto', sans-serif; border:0; padding: 10px; border:1px solid #dbdbdb;  border-radius: 3px; width:90%;}
.frmLabel{display: block; margin-bottom: 10px; font-weight: bold;}
.frmValidation{font-size: 13px; }
.frmValidation--passed{color:#717b85;}
.frmIcon{color:#EB0029;}
.frmValidation--passed .frmIcon{color:#0fa140;}
.howToBuild{ text-align:center; color:purple;}
.howToBuild a{ color:grey; font-weight:bold; text-decoration:none; text-transform:uppercase; }
.VuePassword__Meter {
  height: 4px;
}
</style>
<style v-if="!showMobile">
  .frmValidation{
    font-size: 18px;
    padding: 6px;
    float: left;
    background-color: #f1f1f1;
    margin-right: 8px;
  }
</style>


// WEBPACK FOOTER //
// Password.vue?18742a58